export default function Divider() {
  return (
    <div className="divider max-w-[573px] h-[1px] w-full bg-orange my-8"></div>
  );
}
